export const SECURITY_HEADER = "x-authorization-key";
export const BALLOT_DOCUMENT_TYPE = 67;
export const TITULARIDADE_SEGURO_DOCUMENT_TYPE = 68;
export const CERTIDAO_SUBMISSAO_DOCUMENT_TYPE = 70;
export const GOOD_STANDING_DOCUMENT_TYPE = 71;
export const CERTIDAO_DIRETIVA_SUICA_DOCUMENT_TYPE = 72;
export const CERTIDAO_DIRETIVA_UK_DOCUMENT_TYPE = 73;
export const CERTIDAO_DIRETIVA_EUROPA_DOCUMENT_TYPE = 74;
export const CERTIDAO_SITUACAO_REGULAR_DOCUMENT_TYPE = 75;
export const CERTIFICADO_PARTICIPACAO_DOCUMENT_TYPE = 76;
export const NOTIFICACAO_DIVIDA_DOCUMENT_TYPE = 77;
export const CERTIDAO_DIVIDA_DOCUMENT_TYPE = 78;

export const APP_REF_AREA_MEMBROS = "ee6233fb0080350dca438317ba95ef1b";

export const PAGE_PROFILE = "profile";
export const PAGE_QUOTE = "quote";
export const PAGE_SUPPORT = "support";
export const PAGE_STORE = "store";
export const PAGE_FINANCE = "finance";

export const PALOP_COUNTRIES = [
    'Portugal',
    'Brasil',
    'Angola',
    'Cabo Verde',
    'Guiné-bissau',
    'Guiné Equatorial',
    'Moçambique',
    'São Tomé e Príncipe'
];

export const PAYMENT_STATE_PAYED = "Pago";
export const PAYMENT_STATE_WAITING_PAYMENT = "Aguarda pagamento";
export const PAYMENT_STATE_CANCELLED = "Cancelado";

export const PAYMENT_TYPE_REGISTRATION = "Registo na Ordem dos Fisioterapeutas";
export const PAYMENT_TYPE_ENROLLMENT = "Inscrição na Ordem dos Fisioterapeutas";

export const QUOTE_STATE_PAYED = "Pago";
export const QUOTE_STATE_WAITING_PAYMENT = "Aguarda pagamento";
export const QUOTE_STATE_FREE = "Isento";

export const QUOTE_START_YEAR = 2022;
export const QUOTE_CURRENT_CONFIG_YEAR = 2025;
export const QUOTE_ALL_YEARS = "Todos";

export const YES_OPTION = { name: 'Sim', code: 'Sim' };
export const NO_OPTION = { name: 'Não', code: 'Não' };

export const EN_YES_OPTION = { name: 'Yes', code: 'Sim' };
export const EN_NO_OPTION = { name: 'No', code: 'Não' };

export const FR_YES_OPTION = { name: 'Oui', code: 'Sim' };
export const FR_NO_OPTION = { name: 'Non', code: 'Não' };

export const ES_YES_OPTION = { name: 'Sí', code: 'Sim' };
export const ES_NO_OPTION = { name: 'No', code: 'Não' };

export const DROPDOWN_YES_NO = [
    YES_OPTION,
    NO_OPTION
];

export const PAYMENT_CHANNEL_MB = "Multibanco";
export const PAYMENT_CHANNEL_MBWAY = "MB WAY";
export const PAYMENT_CHANNEL_CREDIT_CARD = "Cartão Crédito";
export const PAYMENT_CHANNEL_BANK_TRANSFER = "Transferência Bancária";
export const PAYMENT_CHANNEL_DIRECT_DEBIT = "Débito Direto";

export const ORDER_STATE_PAYED = "Pago";
export const ORDER_STATE_WAITING_PAYMENT = "Aguarda pagamento";
export const ORDER_STATE_CANCELLED = "Cancelado";

export const TRAINING_REGISTRATION_STATE_CLOSED = "Concluído";
export const TRAINING_REGISTRATION_STATE_WAITING_PAYMENT = "Aguarda pagamento";
export const TRAINING_REGISTRATION_STATE_CANCELLED = "Cancelado";

// Identification doc types
export const DOC_TYPE_PHOTO = 1;
export const DOC_TYPE_IDENTIFICATION = 2;
export const DOC_TYPE_CRIMINAL = 3;
export const DOC_TYPE_RESIDENCE_COMP = 4;
export const DOC_TYPE_SIGNATURE = 15;

// Ballot doc types
export const DOC_TYPE_COMP_CPE = 5;
export const DOC_TYPE_COMP_REGISTRATION_EU = 16;
export const DOC_TYPE_COMP_REGISTRATION_NON_EU = 17;
export const DOC_TYPE_PROFESSIONAL_HONOR = 18;

// Qualification doc types
export const DOC_TYPE_CERT_HAB = 6;
export const DOC_TYPE_DEGREE = 7;
export const DOC_TYPE_COMP_RECOGNITION = 8;
export const DOC_TYPE_PORTUGUESE_LANGUAGE = 9;
export const DOC_TYPE_STUDY_PLAN = 19;

export const DOC_CLINICAL_EDUCATION_ENTRY_LEVEL = 38;
export const DOC_CLINICAL_EDUCATION_POSTGRADUATE = 39;
export const DOC_CLINICAL_EDUCATION_PROFESSIONAL = 40;
export const DOC_CORE_AREAS_COMPETENCES_COMPULSORY = 41;
export const DOC_CORE_AREAS_COMPETENCES_POSTGRADUATE = 42;
export const DOC_CORE_AREAS_COMPETENCES_PROFESSIONAL = 43;

export const DOC_CERT_RECOGNITION = 44;
export const DOC_CERT_BACHAREL = 45;
export const DOC_CERT_GRADUATION = 46;

// Professional doc types
export const DOC_TYPE_PROFESSIONAL_ADDRESS = 12;
export const DOC_TYPE_GOOD_STANDING = 13;

// Post grad doc types
export const DOC_TYPE_CERT_HAB_FISIO = [10, 20, 21, 22, 23, 24, 25, 26, 27, 28];
export const DOC_TYPE_CERT_HAB_NON_FISIO = [11, 29, 30, 31, 32, 33, 34, 35, 36, 37];
export const DOC_TYPE_CERT_EQUIV_FISIO = [47, 48, 49, 50, 51, 52, 53, 54, 55, 56];
export const DOC_TYPE_CERT_EQUIV_NON_FISIO = [57, 58, 59, 60, 61, 62, 63, 64, 65, 66];

// Other doc types
export const DOC_TYPE_CV = 14;

// Quote plans
export const QUOTE_PLAN_MONTHLY = 1;
export const QUOTE_PLAN_SEMESTRAL = 2;
export const QUOTE_PLAN_ANNUAL = 3;

// Payment methods
export const PAYMENT_METHOD_MB = 1;
export const PAYMENT_METHOD_CC = 2;
export const PAYMENT_METHOD_MBWAY = 3;
export const PAYMENT_METHOD_DEBIT_DIRECT = 5;

// Payment types
export const PAYMENT_TYPE_REGISTRATION_INITIAL = 1;
export const PAYMENT_TYPE_REGISTRATION_FINAL = 2;
export const PAYMENT_TYPE_QUOTE = 3;

// Invoice types
export const PERSONAL_DATA = 1;
export const PERSONAL_COMPANY_DATA = 2;
export const COMPANY_DATA = 3;

// Associate data areas
export const PERSONAL = 1;
export const PHYSIO_POST_GRADS = 2;
export const OTHER_POST_GRADS = 3;
export const OTHER_QUALIFICATION = 4;
export const PROFESSIONAL = 5;
export const OTHER_ROLES = 6;
export const CV = 7;

// Action log type
export const ACTION_LOG_DATA = "data";
export const ACTION_LOG_QUOTE = "quote";
export const ACTION_LOG_DIRECT_DEBIT = "direct-debit";

// Registration states
export const REGISTRATION_STATE_REVISION = 3;
export const REGISTRATION_STATE_APPROVED = 14;
export const REGISTRATION_STATE_SUSPENDED = 19;

// Allowance states 
export const ORGANIC_UNIT_APPROVAL = 1;
export const FINANCE_APPROVAL = 2;
export const DIRECTION_APPROVAL = 3;
export const ALLOWANCE_APPROVED = 4;
export const ALLOWANCE_NOT_APPROVED = 5;
export const ALLOWANCE_PAYED = 6;
export const DECISION_APPROVAL = 7;
export const DECISION_WAIT_PAYMENT = 8;
export const DECISION_WAIT_EXPENSE_SUBMISSION = 9;

// Allowance types
export const ALLOWANCE_TYPE_MEAL_TRAVEL = 2;
export const ALLOWANCE_TYPE_PRESENCE_TICKET = 3;

// Allowance expense type
export const ALLOWANCE_EXPENSE_TYPE_HOTEL = 1;
export const ALLOWANCE_EXPENSE_TYPE_MEAL = 2;
export const ALLOWANCE_EXPENSE_TYPE_BUS = 3;
export const ALLOWANCE_EXPENSE_TYPE_TRAIN = 4;
export const ALLOWANCE_EXPENSE_TYPE_TAXI = 5;
export const ALLOWANCE_EXPENSE_TYPE_PLANE = 6;
export const ALLOWANCE_EXPENSE_TYPE_CAR = 7;

export const ASSOCIATE_SUBMISSION = "Trata o Requerente";

export const UNIT_KM_VALUE = 0.4;

export const ALLOWANCE_REQUEST_MAX_DAYS = 365;

// Qualification other option
export const QUALIFICATION_NONE = "Nenhuma";
export const PREFERRED_CONTACT_EMAIL = "E-mail";

// Online store products
export const MUDANCA_NOME_PROFISSIONAL_PRODUCT = "17638561-e8b3-4c9b-b682-3a5cbcc29fde";
export const VINHETAS_PAPEL_PRODUCT = "52e5ad55-0d47-4ed7-9054-902a70b8ec4f";
export const VINHETAS_DIGITAL_PRODUCT = "5ea6e8c9-2373-4a04-b0bc-bbfae562c96b";
export const CEDULA_SEM_ENTREGA_PRODUCT = "7d29f02f-95e5-4318-b5b7-935bf22a9e97";
export const CEDULA_COM_ENTREGA_PRODUCT = "c2742ea4-3d97-43e4-a49e-34536fa11c7c";
export const GOOD_STANDING_PRODUCT = "e9ddff8b-de53-4b97-8f3e-39558c341648";
export const SEGURO_PROFISSIONAL_PRODUCT = "fc225506-3197-470a-822e-8353659c925e";
export const CERTIDAO_DIRETIVA_PRODUCT = "6673d88d-910b-4de5-a003-d95621e4cd90";
export const CERTIDAO_NAO_SUBMISSAO_PRODUCT = "75923882-405b-446c-9e8e-f11238a17253";
export const CERTIDAO_SUBMISSAO_PRODUCT = "2e60c073-eaf5-4687-89fe-329c9d0b8ee4";
export const LEVANTAMENTO_SUSPENSAO_PRODUCT = "35d8fb8d-4284-459b-aa5f-b177b83bc587";
export const PEDIDO_SUSPENSAO_PRODUCT = "584668ec-d871-4139-b8f4-2d83ee6460c6";
export const DECLARACAO_SEGURO_PRODUCT = "fc225506-3197-470a-822e-8353659c925e";
export const CERTIDAO_SITUACAO_REGULAR_PRODUCT = "5140ff85-1f81-4826-ae2c-699fc0d15581";

// Public content pages
export const ORGS_DIRECTION_PAGE = "ab204e17-6843-4ae1-a758-0e6f5dbe269c";
export const ORGS_GENERAL_COUNCIL_PAGE = "a295e4aa-76bd-4fe5-961a-cd4a685edfb0";
export const ORGS_LEGAL_COUNCIL_PAGE = "64b8e084-3e4e-4f0d-a946-d4e7ce08ded5";
export const ORGS_FINANCE_COUNCIL_PAGE = "8dfeb0da-092f-46ee-9307-cfe21e611875";
export const CTA_PAGE = "bf786da6-925d-4226-a379-05f09742f501";
export const STUDY_PLANNING_PAGE = "810e9f74-277b-4870-b744-3cc15fc569eb";
export const COMMUNICATION_PAGE = "f65403df-604d-43b4-aef6-9146bc7e7306";
export const ACTIVITY_REPORT_PAGE = "52eaa299-b8ac-42b0-9cc4-0e3899686f94";
export const PHYSIO_ETHICS_PAGE = "ddfe96d5-9ebb-4ded-b059-a266fc4144b9";
export const PHYSIO_DISTRIBUTION_PAGE = "c6f82b62-21cd-4f4b-a135-95a1ef7ed94f";
export const PHYSIO_SPECIALITY_PAGE = "10ccc273-d545-438d-aac2-513b7268a35e";
export const PHYSIO_INT_MOBILITY_PAGE = "cfd937e5-d737-4441-b3f3-fc63ee1405fe";
export const PHYSIO_SUPPORT_PAGE = "fa12f3a6-d82f-4793-be12-d3f80b2ba28d";
export const PHYSIO_DOCUMENTATION_PAGE = "a5187023-94c1-449d-a25d-2789379af861";
export const PHYSIO_FAQ_PAGE = "23fe14be-ea10-4d41-90fc-218eda78fbef";
export const PEOPLE_PHYSIO_PAGE = "0c8a9834-c6b3-4e6c-b842-b5eb4a8387fc";

export const INFO_MENU_OPTIONS = [
    { id: ORGS_DIRECTION_PAGE, title: "Órgãos Sociais - Direção" },
    { id: ORGS_GENERAL_COUNCIL_PAGE, title: "Órgãos Sociais - Conselho Geral" },
    { id: ORGS_LEGAL_COUNCIL_PAGE, title: "Órgãos Sociais - Conselho Jurisdicional" },
    { id: ORGS_FINANCE_COUNCIL_PAGE, title: "Órgãos Sociais - Conselho Fiscal" },
    { id: CTA_PAGE, title: "Comissão Técnica de Admissão" },
    { id: STUDY_PLANNING_PAGE, title: "Gabinete de Estudos e Planeamento" },
    { id: COMMUNICATION_PAGE, title: "Gabinete de Comunicação e Imagem" },
    { id: ACTIVITY_REPORT_PAGE, title: "Relatório de atividades" },
    { id: PHYSIO_ETHICS_PAGE, title: "Fisioterapeutas - Código de Ética" },
    { id: PHYSIO_DISTRIBUTION_PAGE, title: "Fisioterapeutas - Caracterização dos Fisioterapeutas Inscritos" },
    { id: PHYSIO_SPECIALITY_PAGE, title: "Fisioterapeutas - Especialidades" },
    { id: PHYSIO_INT_MOBILITY_PAGE, title: "Fisioterapeutas - Mobilidade internacional" },
    { id: PHYSIO_SUPPORT_PAGE, title: "Fisioterapeutas - Gabinete de Apoio" },
    { id: PHYSIO_DOCUMENTATION_PAGE, title: "Fisioterapeutas - Repositório documental e científico" },
    { id: PHYSIO_FAQ_PAGE, title: "Fisioterapeutas - Perguntas frequentes" },
    { id: PEOPLE_PHYSIO_PAGE, title: "Cidadão - O que o Fisioterapeuta pode fazer por si" }
];

// Step 1
export const FORM_FIELD_AGREEMENT_1 = "agreement1";
export const FORM_FIELD_AGREEMENT_2 = "agreement2";
export const FORM_FIELD_AGREEMENT_3 = "agreement3";
export const FORM_FIELD_AGREEMENT_4 = "agreement4";
export const FORM_STEP_1_STATE = "step1State";
// Step 2
export const FORM_FIELD_NAME = "nome_completo";
export const FORM_FIELD_PROFESSIONAL_NAME = "nome_profissional";
export const FORM_FIELD_BIRTH_DATE = "data_nascimento";
export const FORM_FIELD_PORTUGUESE_CITIZEN = "cidadao_portugues";
export const FORM_FIELD_PORTUGUESE_ADDRESS = "tem_morada_ativa_em_portugal";
export const FORM_FIELD_IDENTIFICATION_NUMBER = "numero_documento_identificacao";
export const FORM_FIELD_STREET_TYPE = "arteriaCTT";
export const FORM_FIELD_ADDRESS_LINE = "morada1";
export const FORM_FIELD_DOOR_NUMBER = "porta";
export const FORM_FIELD_DOOR_FLOOR = "andar";
export const FORM_FIELD_AUX_PLACE = "localidade_auxiliar";
export const FORM_FIELD_CP4 = "codigo_postal1";
export const FORM_FIELD_CP3 = "codigo_postal2";
export const FORM_FIELD_CITY = "localidade";
export const FORM_FIELD_COUNTY = "concelho";
export const FORM_FIELD_DISTRICT = "distrito";
export const FORM_FIELD_EMAIL = "email";
export const FORM_FIELD_TELEPHONE_PREFIX = "telephonePrefix";
export const FORM_FIELD_TELEPHONE = "telefone_fixo";
export const FORM_FIELD_MOBILE_PHONE_PREFIX = "mobilePhonePrefix";
export const FORM_FIELD_MOBILE_PHONE = "telefone_movel";
export const FORM_FIELD_PREFERRED_CONTACT = "contacto_preferencial";
export const FORM_FIELD_NATIONALITY = "nacionalidade";
export const FORM_FIELD_BIRTH_PLACE = "naturalidade";
export const FORM_FIELD_FATHER = "filiacao_pai";
export const FORM_FIELD_MOTHER = "filiacao_mae";
export const FORM_FIELD_GENDER = "genero";
export const FORM_FIELD_NIF_COUNTRY = "pais_do_nif";
export const FORM_FIELD_NIF = "nif";
export const FORM_STEP_2_STATE = "step2State";
// Step 3
export const FORM_FIELD_PREVIOUS_REGISTRATION = "ja_esteve_inscrito_como_fisioterapeuta";
export const FORM_FIELD_ACSS_BALLOT = "possui_cedula_acss";
export const FORM_FIELD_BALLOT_COUNTRY_EUEFTA = "ballot_country_eu_efta";
export const FORM_FIELD_CPE_BALLOT = "tem_carteira_profissional_europeia";
export const FORM_FIELD_ACSS_BALLOT_NUMBER = "numero_cedula";
export const FORM_FIELD_CPE_BALLOT_NUMBER = "numero_processo";
export const FORM_FIELD_BALLOT_COUNTRY = "pais_eu_efta";
export const FORM_FIELD_CPE_BALLOT_ENTITY = "entidade_emissora";
export const FORM_FIELD_CPE_ENTITY = "entidade_emissora";
export const FORM_STEP_3_STATE = "step3State";
// Step 4
export const FORM_FIELD_QUALIFICATION_TYPE = "tipo_habilitacao";
export const FORM_FIELD_QUALIFICATION_PT_LEARNING_PATH = "percurso_formacao";
export const FORM_FIELD_QUALIFICATION_PT_BACHELOR_SCHOOL = "entidade_formadora_bacharel";
export const FORM_FIELD_QUALIFICATION_PT_BACHELOR_END_DATE = "data_conclusao_bacharel";
export const FORM_FIELD_QUALIFICATION_PT_GRADUATION_SCHOOL = "entidade_formadora_licenciatura";
export const FORM_FIELD_QUALIFICATION_PT_GRADUATION_END_DATE = "data_conclusao_licenciatura";
export const FORM_FIELD_QUALIFICATION_PT_TRAINING_PRE_REQS = "pre_requisitos_ingresso";
export const FORM_FIELD_QUALIFICATION_PT_TRAINING_DURATION = "duracao_da_formacao";
export const FORM_FIELD_QUALIFICATION_PT_TRAINING_END_DATE = "data_conclusao";
export const FORM_FIELD_QUALIFICATION_PT_TRAINING_SCHOOL = "entidade_formadora";
export const FORM_FIELD_QUALIFICATION_PT_ACCEPTANCE_END_DATE = "data_equivalencia";
export const FORM_FIELD_QUALIFICATION_PT_ACCEPTANCE_SCHOOL = "entidade_equivalencia";
export const FORM_FIELD_QUALIFICATION_EU_OTHER_ACCEPTANCE_SCHOOL = "outra_entidade_reconhecimento";
export const FORM_FIELD_QUALIFICATION_EU_ACCEPTANCE_SCHOOL = "equivalencia";
export const FORM_FIELD_QUALIFICATION_EU_ACCEPTANCE_YEAR = "ano_equivalencia";
export const FORM_FIELD_QUALIFICATION_EU_DEGREE_LEVEL = "grau_academico";
export const FORM_FIELD_QUALIFICATION_EU_PORTUGUESE_LEVEL = "proficiencia_lingua_portuguesa";
export const FORM_FIELD_QUALIFICATION_EU_POST_TRAINING_TYPE = "acesso_a_pratica_clinica";
export const FORM_FIELD_QUALIFICATION_EU_PRE_TRAINING_YEARS = "n_anos_escolaridade";
export const FORM_FIELD_QUALIFICATION_EU_TRAINING_COUNTRY = "pais_onde_tirou_formacao";
export const FORM_FIELD_QUALIFICATION_EU_TRAINING_DURATION = "duracao_da_formacao2";
export const FORM_FIELD_QUALIFICATION_EU_TRAINING_SCHOOL = "escola_onde_tirou_formacao";
export const FORM_FIELD_QUALIFICATION_NON_EU_OTHER_ACCEPTANCE_SCHOOL = "outra_entidade_reconhecimento";
export const FORM_FIELD_QUALIFICATION_NON_EU_ACCEPTANCE_SCHOOL = "equivalencia";
export const FORM_FIELD_QUALIFICATION_NON_EU_ACCEPTANCE_YEAR = "ano_equivalencia";
export const FORM_FIELD_QUALIFICATION_NON_EU_BALLOT_NUMBER = "numero_cedula_formacao_fora_ue";
export const FORM_FIELD_QUALIFICATION_NON_EU_DEGREE_LEVEL = "grau_academico";
export const FORM_FIELD_QUALIFICATION_NON_EU_PORTUGUESE_LEVEL = "proficiencia_lingua_portuguesa";
export const FORM_FIELD_QUALIFICATION_NON_EU_PRE_TRAINING_YEARS = "n_anos_escolaridade";
export const FORM_FIELD_QUALIFICATION_NON_EU_TRAINING_COUNTRY = "pais_onde_tirou_formacao";
export const FORM_FIELD_QUALIFICATION_NON_EU_TRAINING_DURATION = "duracao_da_formacao_anos";
export const FORM_FIELD_QUALIFICATION_NON_EU_TRAINING_SCHOOL = "escola_onde_tirou_formacao";
export const FORM_STEP_4_STATE = "step4State";
// Step 5
export const FORM_STEP_5_STATE = "step5State";

export const FORM_FIELD_HAS_PHYSIO_POST_GRAD = "tem_graduacao_em_fisioterapia";

export const FORM_FIELD_PHYSIO_POST_GRAD_DEGREE_LEVEL = "grau_academico_em_fisioterapia";
export const FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_TITLE = "titulo_curso_em_fisioterapia";
export const FORM_FIELD_PHYSIO_POST_GRAD_END_DATE = "data_conclusao_em_fisioterapia";
export const FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_SCHOOL = "entidade_formadora_em_fisioterapia";
export const FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_COUNTRY = "pais_da_entidade_formadora_em_fisioterapia";
export const FORM_FIELD_PHYSIO_POST_GRAD_ACCEPTANCE_SCHOOL = "entidade_reconhecimento_equivalencia_em_fisioterapia";
export const FORM_FIELD_PHYSIO_POST_GRAD_ACCEPTANCE_DATE = "data_reconhecimento_equivalencia_em_fisioterapia";

export const FORM_FIELD_PHYSIO_POST_GRAD_DEGREE_LEVEL_1 = FORM_FIELD_PHYSIO_POST_GRAD_DEGREE_LEVEL + "1";
export const FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_TITLE_1 = FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_TITLE + "1";
export const FORM_FIELD_PHYSIO_POST_GRAD_END_DATE_1 = FORM_FIELD_PHYSIO_POST_GRAD_END_DATE + "1";
export const FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_SCHOOL_1 = FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_SCHOOL + "1";
export const FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_COUNTRY_1 = FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_COUNTRY + "1";
export const FORM_FIELD_PHYSIO_POST_GRAD_ACCEPTANCE_SCHOOL_1 = FORM_FIELD_PHYSIO_POST_GRAD_ACCEPTANCE_SCHOOL + "1";
export const FORM_FIELD_PHYSIO_POST_GRAD_ACCEPTANCE_DATE_1 = FORM_FIELD_PHYSIO_POST_GRAD_ACCEPTANCE_DATE + "1";

export const FORM_FIELD_PHYSIO_POST_GRAD_DEGREE_LEVEL_2 = FORM_FIELD_PHYSIO_POST_GRAD_DEGREE_LEVEL + "2";
export const FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_TITLE_2 = FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_TITLE + "2";
export const FORM_FIELD_PHYSIO_POST_GRAD_END_DATE_2 = FORM_FIELD_PHYSIO_POST_GRAD_END_DATE + "2";
export const FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_SCHOOL_2 = FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_SCHOOL + "2";
export const FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_COUNTRY_2 = FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_COUNTRY + "2";
export const FORM_FIELD_PHYSIO_POST_GRAD_ACCEPTANCE_SCHOOL_2 = FORM_FIELD_PHYSIO_POST_GRAD_ACCEPTANCE_SCHOOL + "2";
export const FORM_FIELD_PHYSIO_POST_GRAD_ACCEPTANCE_DATE_2 = FORM_FIELD_PHYSIO_POST_GRAD_ACCEPTANCE_DATE + "2";

export const FORM_FIELD_PHYSIO_POST_GRAD_DEGREE_LEVEL_3 = FORM_FIELD_PHYSIO_POST_GRAD_DEGREE_LEVEL + "3";
export const FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_TITLE_3 = FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_TITLE + "3";
export const FORM_FIELD_PHYSIO_POST_GRAD_END_DATE_3 = FORM_FIELD_PHYSIO_POST_GRAD_END_DATE + "3";
export const FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_SCHOOL_3 = FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_SCHOOL + "3";
export const FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_COUNTRY_3 = FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_COUNTRY + "3";
export const FORM_FIELD_PHYSIO_POST_GRAD_ACCEPTANCE_SCHOOL_3 = FORM_FIELD_PHYSIO_POST_GRAD_ACCEPTANCE_SCHOOL + "3";
export const FORM_FIELD_PHYSIO_POST_GRAD_ACCEPTANCE_DATE_3 = FORM_FIELD_PHYSIO_POST_GRAD_ACCEPTANCE_DATE + "3";

export const FORM_FIELD_PHYSIO_POST_GRAD_DEGREE_LEVEL_4 = FORM_FIELD_PHYSIO_POST_GRAD_DEGREE_LEVEL + "4";
export const FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_TITLE_4 = FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_TITLE + "4";
export const FORM_FIELD_PHYSIO_POST_GRAD_END_DATE_4 = FORM_FIELD_PHYSIO_POST_GRAD_END_DATE + "4";
export const FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_SCHOOL_4 = FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_SCHOOL + "4";
export const FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_COUNTRY_4 = FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_COUNTRY + "4";
export const FORM_FIELD_PHYSIO_POST_GRAD_ACCEPTANCE_SCHOOL_4 = FORM_FIELD_PHYSIO_POST_GRAD_ACCEPTANCE_SCHOOL + "4";
export const FORM_FIELD_PHYSIO_POST_GRAD_ACCEPTANCE_DATE_4 = FORM_FIELD_PHYSIO_POST_GRAD_ACCEPTANCE_DATE + "4";

export const FORM_FIELD_PHYSIO_POST_GRAD_DEGREE_LEVEL_5 = FORM_FIELD_PHYSIO_POST_GRAD_DEGREE_LEVEL + "5";
export const FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_TITLE_5 = FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_TITLE + "5";
export const FORM_FIELD_PHYSIO_POST_GRAD_END_DATE_5 = FORM_FIELD_PHYSIO_POST_GRAD_END_DATE + "5";
export const FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_SCHOOL_5 = FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_SCHOOL + "5";
export const FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_COUNTRY_5 = FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_COUNTRY + "5";
export const FORM_FIELD_PHYSIO_POST_GRAD_ACCEPTANCE_SCHOOL_5 = FORM_FIELD_PHYSIO_POST_GRAD_ACCEPTANCE_SCHOOL + "5";
export const FORM_FIELD_PHYSIO_POST_GRAD_ACCEPTANCE_DATE_5 = FORM_FIELD_PHYSIO_POST_GRAD_ACCEPTANCE_DATE + "5";

export const FORM_FIELD_PHYSIO_POST_GRAD_DEGREE_LEVEL_6 = FORM_FIELD_PHYSIO_POST_GRAD_DEGREE_LEVEL + "6";
export const FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_TITLE_6 = FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_TITLE + "6";
export const FORM_FIELD_PHYSIO_POST_GRAD_END_DATE_6 = FORM_FIELD_PHYSIO_POST_GRAD_END_DATE + "6";
export const FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_SCHOOL_6 = FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_SCHOOL + "6";
export const FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_COUNTRY_6 = FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_COUNTRY + "6";
export const FORM_FIELD_PHYSIO_POST_GRAD_ACCEPTANCE_SCHOOL_6 = FORM_FIELD_PHYSIO_POST_GRAD_ACCEPTANCE_SCHOOL + "6";
export const FORM_FIELD_PHYSIO_POST_GRAD_ACCEPTANCE_DATE_6 = FORM_FIELD_PHYSIO_POST_GRAD_ACCEPTANCE_DATE + "6";

export const FORM_FIELD_PHYSIO_POST_GRAD_DEGREE_LEVEL_7 = FORM_FIELD_PHYSIO_POST_GRAD_DEGREE_LEVEL + "7";
export const FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_TITLE_7 = FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_TITLE + "7";
export const FORM_FIELD_PHYSIO_POST_GRAD_END_DATE_7 = FORM_FIELD_PHYSIO_POST_GRAD_END_DATE + "7";
export const FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_SCHOOL_7 = FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_SCHOOL + "7";
export const FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_COUNTRY_7 = FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_COUNTRY + "7";
export const FORM_FIELD_PHYSIO_POST_GRAD_ACCEPTANCE_SCHOOL_7 = FORM_FIELD_PHYSIO_POST_GRAD_ACCEPTANCE_SCHOOL + "7";
export const FORM_FIELD_PHYSIO_POST_GRAD_ACCEPTANCE_DATE_7 = FORM_FIELD_PHYSIO_POST_GRAD_ACCEPTANCE_DATE + "7";

export const FORM_FIELD_PHYSIO_POST_GRAD_DEGREE_LEVEL_8 = FORM_FIELD_PHYSIO_POST_GRAD_DEGREE_LEVEL + "8";
export const FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_TITLE_8 = FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_TITLE + "8";
export const FORM_FIELD_PHYSIO_POST_GRAD_END_DATE_8 = FORM_FIELD_PHYSIO_POST_GRAD_END_DATE + "8";
export const FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_SCHOOL_8 = FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_SCHOOL + "8";
export const FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_COUNTRY_8 = FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_COUNTRY + "8";
export const FORM_FIELD_PHYSIO_POST_GRAD_ACCEPTANCE_SCHOOL_8 = FORM_FIELD_PHYSIO_POST_GRAD_ACCEPTANCE_SCHOOL + "8";
export const FORM_FIELD_PHYSIO_POST_GRAD_ACCEPTANCE_DATE_8 = FORM_FIELD_PHYSIO_POST_GRAD_ACCEPTANCE_DATE + "8";

export const FORM_FIELD_PHYSIO_POST_GRAD_DEGREE_LEVEL_9 = FORM_FIELD_PHYSIO_POST_GRAD_DEGREE_LEVEL + "9";
export const FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_TITLE_9 = FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_TITLE + "9";
export const FORM_FIELD_PHYSIO_POST_GRAD_END_DATE_9 = FORM_FIELD_PHYSIO_POST_GRAD_END_DATE + "9";
export const FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_SCHOOL_9 = FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_SCHOOL + "9";
export const FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_COUNTRY_9 = FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_COUNTRY + "9";
export const FORM_FIELD_PHYSIO_POST_GRAD_ACCEPTANCE_SCHOOL_9 = FORM_FIELD_PHYSIO_POST_GRAD_ACCEPTANCE_SCHOOL + "9";
export const FORM_FIELD_PHYSIO_POST_GRAD_ACCEPTANCE_DATE_9 = FORM_FIELD_PHYSIO_POST_GRAD_ACCEPTANCE_DATE + "9";

export const FORM_FIELD_PHYSIO_POST_GRAD_DEGREE_LEVEL_10 = FORM_FIELD_PHYSIO_POST_GRAD_DEGREE_LEVEL + "10";
export const FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_TITLE_10 = FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_TITLE + "10";
export const FORM_FIELD_PHYSIO_POST_GRAD_END_DATE_10 = FORM_FIELD_PHYSIO_POST_GRAD_END_DATE + "10";
export const FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_SCHOOL_10 = FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_SCHOOL + "10";
export const FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_COUNTRY_10 = FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_COUNTRY + "10";
export const FORM_FIELD_PHYSIO_POST_GRAD_ACCEPTANCE_SCHOOL_10 = FORM_FIELD_PHYSIO_POST_GRAD_ACCEPTANCE_SCHOOL + "10";
export const FORM_FIELD_PHYSIO_POST_GRAD_ACCEPTANCE_DATE_10 = FORM_FIELD_PHYSIO_POST_GRAD_ACCEPTANCE_DATE + "10";


// Step 6
export const FORM_STEP_6_STATE = "step6State";

export const FORM_FIELD_HAS_OTHER_POST_GRAD = "tem_graduacao_em_outra_area";

export const FORM_FIELD_OTHER_POST_GRAD_DEGREE_LEVEL = "grau_academico_fora_fisioterapia";
export const FORM_FIELD_OTHER_POST_GRAD_TRAINING_TITLE = "titulo_curso_fora_fisioterapia";
export const FORM_FIELD_OTHER_POST_GRAD_END_DATE = "data_conclusao_fora_fisioterapia";
export const FORM_FIELD_OTHER_POST_GRAD_TRAINING_SCHOOL = "entidade_formadora_fora_fisioterapia";
export const FORM_FIELD_OTHER_POST_GRAD_TRAINING_COUNTRY = "pais_da_entidade_formadora_fora_fisioterapia";
export const FORM_FIELD_OTHER_POST_GRAD_ACCEPTANCE_SCHOOL = "entidade_reconhecimento_equivalencia_fora_fisioterapia";
export const FORM_FIELD_OTHER_POST_GRAD_ACCEPTANCE_DATE = "data_reconhecimento_equivalencia_fora_fisioterapia";

export const FORM_FIELD_OTHER_POST_GRAD_DEGREE_LEVEL_1 = FORM_FIELD_OTHER_POST_GRAD_DEGREE_LEVEL + "1";
export const FORM_FIELD_OTHER_POST_GRAD_TRAINING_TITLE_1 = FORM_FIELD_OTHER_POST_GRAD_TRAINING_TITLE + "1";
export const FORM_FIELD_OTHER_POST_GRAD_END_DATE_1 = FORM_FIELD_OTHER_POST_GRAD_END_DATE + "1";
export const FORM_FIELD_OTHER_POST_GRAD_TRAINING_SCHOOL_1 = FORM_FIELD_OTHER_POST_GRAD_TRAINING_SCHOOL + "1";
export const FORM_FIELD_OTHER_POST_GRAD_TRAINING_COUNTRY_1 = FORM_FIELD_OTHER_POST_GRAD_TRAINING_COUNTRY + "1";
export const FORM_FIELD_OTHER_POST_GRAD_ACCEPTANCE_SCHOOL_1 = FORM_FIELD_OTHER_POST_GRAD_ACCEPTANCE_SCHOOL + "1";
export const FORM_FIELD_OTHER_POST_GRAD_ACCEPTANCE_DATE_1 = FORM_FIELD_OTHER_POST_GRAD_ACCEPTANCE_DATE + "1";

export const FORM_FIELD_OTHER_POST_GRAD_DEGREE_LEVEL_2 = FORM_FIELD_OTHER_POST_GRAD_DEGREE_LEVEL + "2";
export const FORM_FIELD_OTHER_POST_GRAD_TRAINING_TITLE_2 = FORM_FIELD_OTHER_POST_GRAD_TRAINING_TITLE + "2";
export const FORM_FIELD_OTHER_POST_GRAD_END_DATE_2 = FORM_FIELD_OTHER_POST_GRAD_END_DATE + "2";
export const FORM_FIELD_OTHER_POST_GRAD_TRAINING_SCHOOL_2 = FORM_FIELD_OTHER_POST_GRAD_TRAINING_SCHOOL + "2";
export const FORM_FIELD_OTHER_POST_GRAD_TRAINING_COUNTRY_2 = FORM_FIELD_OTHER_POST_GRAD_TRAINING_COUNTRY + "2";
export const FORM_FIELD_OTHER_POST_GRAD_ACCEPTANCE_SCHOOL_2 = FORM_FIELD_OTHER_POST_GRAD_ACCEPTANCE_SCHOOL + "2";
export const FORM_FIELD_OTHER_POST_GRAD_ACCEPTANCE_DATE_2 = FORM_FIELD_OTHER_POST_GRAD_ACCEPTANCE_DATE + "2";

export const FORM_FIELD_OTHER_POST_GRAD_DEGREE_LEVEL_3 = FORM_FIELD_OTHER_POST_GRAD_DEGREE_LEVEL + "3";
export const FORM_FIELD_OTHER_POST_GRAD_TRAINING_TITLE_3 = FORM_FIELD_OTHER_POST_GRAD_TRAINING_TITLE + "3";
export const FORM_FIELD_OTHER_POST_GRAD_END_DATE_3 = FORM_FIELD_OTHER_POST_GRAD_END_DATE + "3";
export const FORM_FIELD_OTHER_POST_GRAD_TRAINING_SCHOOL_3 = FORM_FIELD_OTHER_POST_GRAD_TRAINING_SCHOOL + "3";
export const FORM_FIELD_OTHER_POST_GRAD_TRAINING_COUNTRY_3 = FORM_FIELD_OTHER_POST_GRAD_TRAINING_COUNTRY + "3";
export const FORM_FIELD_OTHER_POST_GRAD_ACCEPTANCE_SCHOOL_3 = FORM_FIELD_OTHER_POST_GRAD_ACCEPTANCE_SCHOOL + "3";
export const FORM_FIELD_OTHER_POST_GRAD_ACCEPTANCE_DATE_3 = FORM_FIELD_OTHER_POST_GRAD_ACCEPTANCE_DATE + "3";

export const FORM_FIELD_OTHER_POST_GRAD_DEGREE_LEVEL_4 = FORM_FIELD_OTHER_POST_GRAD_DEGREE_LEVEL + "4";
export const FORM_FIELD_OTHER_POST_GRAD_TRAINING_TITLE_4 = FORM_FIELD_OTHER_POST_GRAD_TRAINING_TITLE + "4";
export const FORM_FIELD_OTHER_POST_GRAD_END_DATE_4 = FORM_FIELD_OTHER_POST_GRAD_END_DATE + "4";
export const FORM_FIELD_OTHER_POST_GRAD_TRAINING_SCHOOL_4 = FORM_FIELD_OTHER_POST_GRAD_TRAINING_SCHOOL + "4";
export const FORM_FIELD_OTHER_POST_GRAD_TRAINING_COUNTRY_4 = FORM_FIELD_OTHER_POST_GRAD_TRAINING_COUNTRY + "4";
export const FORM_FIELD_OTHER_POST_GRAD_ACCEPTANCE_SCHOOL_4 = FORM_FIELD_OTHER_POST_GRAD_ACCEPTANCE_SCHOOL + "4";
export const FORM_FIELD_OTHER_POST_GRAD_ACCEPTANCE_DATE_4 = FORM_FIELD_OTHER_POST_GRAD_ACCEPTANCE_DATE + "4";

export const FORM_FIELD_OTHER_POST_GRAD_DEGREE_LEVEL_5 = FORM_FIELD_OTHER_POST_GRAD_DEGREE_LEVEL + "5";
export const FORM_FIELD_OTHER_POST_GRAD_TRAINING_TITLE_5 = FORM_FIELD_OTHER_POST_GRAD_TRAINING_TITLE + "5";
export const FORM_FIELD_OTHER_POST_GRAD_END_DATE_5 = FORM_FIELD_OTHER_POST_GRAD_END_DATE + "5";
export const FORM_FIELD_OTHER_POST_GRAD_TRAINING_SCHOOL_5 = FORM_FIELD_OTHER_POST_GRAD_TRAINING_SCHOOL + "5";
export const FORM_FIELD_OTHER_POST_GRAD_TRAINING_COUNTRY_5 = FORM_FIELD_OTHER_POST_GRAD_TRAINING_COUNTRY + "5";
export const FORM_FIELD_OTHER_POST_GRAD_ACCEPTANCE_SCHOOL_5 = FORM_FIELD_OTHER_POST_GRAD_ACCEPTANCE_SCHOOL + "5";
export const FORM_FIELD_OTHER_POST_GRAD_ACCEPTANCE_DATE_5 = FORM_FIELD_OTHER_POST_GRAD_ACCEPTANCE_DATE + "5";

export const FORM_FIELD_OTHER_POST_GRAD_DEGREE_LEVEL_6 = FORM_FIELD_OTHER_POST_GRAD_DEGREE_LEVEL + "6";
export const FORM_FIELD_OTHER_POST_GRAD_TRAINING_TITLE_6 = FORM_FIELD_OTHER_POST_GRAD_TRAINING_TITLE + "6";
export const FORM_FIELD_OTHER_POST_GRAD_END_DATE_6 = FORM_FIELD_OTHER_POST_GRAD_END_DATE + "6";
export const FORM_FIELD_OTHER_POST_GRAD_TRAINING_SCHOOL_6 = FORM_FIELD_OTHER_POST_GRAD_TRAINING_SCHOOL + "6";
export const FORM_FIELD_OTHER_POST_GRAD_TRAINING_COUNTRY_6 = FORM_FIELD_OTHER_POST_GRAD_TRAINING_COUNTRY + "6";
export const FORM_FIELD_OTHER_POST_GRAD_ACCEPTANCE_SCHOOL_6 = FORM_FIELD_OTHER_POST_GRAD_ACCEPTANCE_SCHOOL + "6";
export const FORM_FIELD_OTHER_POST_GRAD_ACCEPTANCE_DATE_6 = FORM_FIELD_OTHER_POST_GRAD_ACCEPTANCE_DATE + "6";

export const FORM_FIELD_OTHER_POST_GRAD_DEGREE_LEVEL_7 = FORM_FIELD_OTHER_POST_GRAD_DEGREE_LEVEL + "7";
export const FORM_FIELD_OTHER_POST_GRAD_TRAINING_TITLE_7 = FORM_FIELD_OTHER_POST_GRAD_TRAINING_TITLE + "7";
export const FORM_FIELD_OTHER_POST_GRAD_END_DATE_7 = FORM_FIELD_OTHER_POST_GRAD_END_DATE + "7";
export const FORM_FIELD_OTHER_POST_GRAD_TRAINING_SCHOOL_7 = FORM_FIELD_OTHER_POST_GRAD_TRAINING_SCHOOL + "7";
export const FORM_FIELD_OTHER_POST_GRAD_TRAINING_COUNTRY_7 = FORM_FIELD_OTHER_POST_GRAD_TRAINING_COUNTRY + "7";
export const FORM_FIELD_OTHER_POST_GRAD_ACCEPTANCE_SCHOOL_7 = FORM_FIELD_OTHER_POST_GRAD_ACCEPTANCE_SCHOOL + "7";
export const FORM_FIELD_OTHER_POST_GRAD_ACCEPTANCE_DATE_7 = FORM_FIELD_OTHER_POST_GRAD_ACCEPTANCE_DATE + "7";

export const FORM_FIELD_OTHER_POST_GRAD_DEGREE_LEVEL_8 = FORM_FIELD_OTHER_POST_GRAD_DEGREE_LEVEL + "8";
export const FORM_FIELD_OTHER_POST_GRAD_TRAINING_TITLE_8 = FORM_FIELD_OTHER_POST_GRAD_TRAINING_TITLE + "8";
export const FORM_FIELD_OTHER_POST_GRAD_END_DATE_8 = FORM_FIELD_OTHER_POST_GRAD_END_DATE + "8";
export const FORM_FIELD_OTHER_POST_GRAD_TRAINING_SCHOOL_8 = FORM_FIELD_OTHER_POST_GRAD_TRAINING_SCHOOL + "8";
export const FORM_FIELD_OTHER_POST_GRAD_TRAINING_COUNTRY_8 = FORM_FIELD_OTHER_POST_GRAD_TRAINING_COUNTRY + "8";
export const FORM_FIELD_OTHER_POST_GRAD_ACCEPTANCE_SCHOOL_8 = FORM_FIELD_OTHER_POST_GRAD_ACCEPTANCE_SCHOOL + "8";
export const FORM_FIELD_OTHER_POST_GRAD_ACCEPTANCE_DATE_8 = FORM_FIELD_OTHER_POST_GRAD_ACCEPTANCE_DATE + "8";

export const FORM_FIELD_OTHER_POST_GRAD_DEGREE_LEVEL_9 = FORM_FIELD_OTHER_POST_GRAD_DEGREE_LEVEL + "9";
export const FORM_FIELD_OTHER_POST_GRAD_TRAINING_TITLE_9 = FORM_FIELD_OTHER_POST_GRAD_TRAINING_TITLE + "9";
export const FORM_FIELD_OTHER_POST_GRAD_END_DATE_9 = FORM_FIELD_OTHER_POST_GRAD_END_DATE + "9";
export const FORM_FIELD_OTHER_POST_GRAD_TRAINING_SCHOOL_9 = FORM_FIELD_OTHER_POST_GRAD_TRAINING_SCHOOL + "9";
export const FORM_FIELD_OTHER_POST_GRAD_TRAINING_COUNTRY_9 = FORM_FIELD_OTHER_POST_GRAD_TRAINING_COUNTRY + "9";
export const FORM_FIELD_OTHER_POST_GRAD_ACCEPTANCE_SCHOOL_9 = FORM_FIELD_OTHER_POST_GRAD_ACCEPTANCE_SCHOOL + "9";
export const FORM_FIELD_OTHER_POST_GRAD_ACCEPTANCE_DATE_9 = FORM_FIELD_OTHER_POST_GRAD_ACCEPTANCE_DATE + "9";

export const FORM_FIELD_OTHER_POST_GRAD_DEGREE_LEVEL_10 = FORM_FIELD_OTHER_POST_GRAD_DEGREE_LEVEL + "10";
export const FORM_FIELD_OTHER_POST_GRAD_TRAINING_TITLE_10 = FORM_FIELD_OTHER_POST_GRAD_TRAINING_TITLE + "10";
export const FORM_FIELD_OTHER_POST_GRAD_END_DATE_10 = FORM_FIELD_OTHER_POST_GRAD_END_DATE + "10";
export const FORM_FIELD_OTHER_POST_GRAD_TRAINING_SCHOOL_10 = FORM_FIELD_OTHER_POST_GRAD_TRAINING_SCHOOL + "10";
export const FORM_FIELD_OTHER_POST_GRAD_TRAINING_COUNTRY_10 = FORM_FIELD_OTHER_POST_GRAD_TRAINING_COUNTRY + "10";
export const FORM_FIELD_OTHER_POST_GRAD_ACCEPTANCE_SCHOOL_10 = FORM_FIELD_OTHER_POST_GRAD_ACCEPTANCE_SCHOOL + "10";
export const FORM_FIELD_OTHER_POST_GRAD_ACCEPTANCE_DATE_10 = FORM_FIELD_OTHER_POST_GRAD_ACCEPTANCE_DATE + "10";

// Step 7
export const FORM_FIELD_MENTAL_HEALTH = "saude_mental";
export const FORM_FIELD_OCCUPATION_HEALTH = "saude_ocupacional";
export const FORM_FIELD_WOMEN_HEALTH = "saude_da_mulher";
export const FORM_FIELD_WELL_BEING_HEALTH = "saude_e_bem_estar";
export const FORM_FIELD_PROMOTION_PROTECTION_HEALTH = "promocao_e_protecao_da_saude";
export const FORM_FIELD_MUSCLE_HEALTH = "muscoloesqueletica";
export const FORM_FIELD_NEURO_HEALTH = "neuromuscular";
export const FORM_FIELD_HEART_HEALTH = "cardiovascular";
export const FORM_FIELD_RESPIRATORY_HEALTH = "respiratorias";
export const FORM_FIELD_INTEGUMENTAL_HEALTH = "tegumentares";
export const FORM_FIELD_ONCOLOGICAL_HEALTH = "oncologicas";
export const FORM_FIELD_ANIMAL_HEALTH = "saude_animal";
export const FORM_FIELD_COMPLEX_SCENARIOS = "elevada_complexidade";
export const FORM_FIELD_OTHER_CONDITIONS = "outras_condicoes";
export const FORM_STEP_7_STATE = "step7State";

// Step 8

export const FORM_FIELD_BUSINESS_OWNER = "proprietario_unidade_fisioterapia";
export const FORM_FIELD_BUSINESS_NAME = "nome_unidade_fisioterapia";
export const FORM_FIELD_PROFESSIONALS_NUMBER = "numero_empregados";
export const FORM_FIELD_HAS_MANAGEMENT_ROLE = "teve_cargo_chefia";
export const FORM_FIELD_HAS_PUBLIC_ADMIN_ROLE = "teve_cargo_administracao_publica";
export const FORM_FIELD_HAS_ETHICS_COMMITTEE_ROLE = "teve_cargo_comissoes_etica";
export const FORM_FIELD_HAS_QUALITY_COMMITTEE_ROLE = "teve_cargo_comissoes_qualidade";
export const FORM_FIELD_HAS_ORGANIZATIONAL_ROLE = "filiado_em_associacoes";

export const FORM_FIELD_MANAGEMENT_ROLE = "cargo_chefia";
export const FORM_FIELD_MANAGEMENT_WORKPLACE = "instituicao_chefia";
export const FORM_FIELD_MANAGEMENT_BEGIN_DATE = "data_inicio_chefia";
export const FORM_FIELD_MANAGEMENT_END_DATE = "data_fim_chefia";
export const FORM_FIELD_MANAGEMENT_PROFESSIONALS_NUMBER = "numero_fisioterapuetas_chefia";

export const FORM_FIELD_MANAGEMENT_ROLE_1 = FORM_FIELD_MANAGEMENT_ROLE + "1";
export const FORM_FIELD_MANAGEMENT_WORKPLACE_1 = FORM_FIELD_MANAGEMENT_WORKPLACE + "1";
export const FORM_FIELD_MANAGEMENT_BEGIN_DATE_1 = FORM_FIELD_MANAGEMENT_BEGIN_DATE + "1";
export const FORM_FIELD_MANAGEMENT_END_DATE_1 = FORM_FIELD_MANAGEMENT_END_DATE + "1";
export const FORM_FIELD_MANAGEMENT_PROFESSIONALS_NUMBER_1 = FORM_FIELD_MANAGEMENT_PROFESSIONALS_NUMBER + "1";

export const FORM_FIELD_MANAGEMENT_ROLE_2 = FORM_FIELD_MANAGEMENT_ROLE + "2";
export const FORM_FIELD_MANAGEMENT_WORKPLACE_2 = FORM_FIELD_MANAGEMENT_WORKPLACE + "2";
export const FORM_FIELD_MANAGEMENT_BEGIN_DATE_2 = FORM_FIELD_MANAGEMENT_BEGIN_DATE + "2";
export const FORM_FIELD_MANAGEMENT_END_DATE_2 = FORM_FIELD_MANAGEMENT_END_DATE + "2";
export const FORM_FIELD_MANAGEMENT_PROFESSIONALS_NUMBER_2 = FORM_FIELD_MANAGEMENT_PROFESSIONALS_NUMBER + "2";

export const FORM_FIELD_MANAGEMENT_ROLE_3 = FORM_FIELD_MANAGEMENT_ROLE + "3";
export const FORM_FIELD_MANAGEMENT_WORKPLACE_3 = FORM_FIELD_MANAGEMENT_WORKPLACE + "3";
export const FORM_FIELD_MANAGEMENT_BEGIN_DATE_3 = FORM_FIELD_MANAGEMENT_BEGIN_DATE + "3";
export const FORM_FIELD_MANAGEMENT_END_DATE_3 = FORM_FIELD_MANAGEMENT_END_DATE + "3";
export const FORM_FIELD_MANAGEMENT_PROFESSIONALS_NUMBER_3 = FORM_FIELD_MANAGEMENT_PROFESSIONALS_NUMBER + "3";

export const FORM_FIELD_PUBLIC_ADMIN_ROLE = "cargo_administracao_publica";
export const FORM_FIELD_PUBLIC_ADMIN_WORKPLACE = "instituicao_administracao_publica";
export const FORM_FIELD_PUBLIC_ADMIN_BEGIN_DATE = "data_inicio_administracao_publica";
export const FORM_FIELD_PUBLIC_ADMIN_END_DATE = "data_fim_administracao_publica";

export const FORM_FIELD_PUBLIC_ADMIN_ROLE_1 = FORM_FIELD_PUBLIC_ADMIN_ROLE + "1";
export const FORM_FIELD_PUBLIC_ADMIN_WORKPLACE_1 = FORM_FIELD_PUBLIC_ADMIN_WORKPLACE + "1";
export const FORM_FIELD_PUBLIC_ADMIN_BEGIN_DATE_1 = FORM_FIELD_PUBLIC_ADMIN_BEGIN_DATE + "1";
export const FORM_FIELD_PUBLIC_ADMIN_END_DATE_1 = FORM_FIELD_PUBLIC_ADMIN_END_DATE + "1";

export const FORM_FIELD_PUBLIC_ADMIN_ROLE_2 = FORM_FIELD_PUBLIC_ADMIN_ROLE + "2";
export const FORM_FIELD_PUBLIC_ADMIN_WORKPLACE_2 = FORM_FIELD_PUBLIC_ADMIN_WORKPLACE + "2";
export const FORM_FIELD_PUBLIC_ADMIN_BEGIN_DATE_2 = FORM_FIELD_PUBLIC_ADMIN_BEGIN_DATE + "2";
export const FORM_FIELD_PUBLIC_ADMIN_END_DATE_2 = FORM_FIELD_PUBLIC_ADMIN_END_DATE + "2";

export const FORM_FIELD_PUBLIC_ADMIN_ROLE_3 = FORM_FIELD_PUBLIC_ADMIN_ROLE + "3";
export const FORM_FIELD_PUBLIC_ADMIN_WORKPLACE_3 = FORM_FIELD_PUBLIC_ADMIN_WORKPLACE + "3";
export const FORM_FIELD_PUBLIC_ADMIN_BEGIN_DATE_3 = FORM_FIELD_PUBLIC_ADMIN_BEGIN_DATE + "3";
export const FORM_FIELD_PUBLIC_ADMIN_END_DATE_3 = FORM_FIELD_PUBLIC_ADMIN_END_DATE + "3";


export const FORM_FIELD_ETHICS_COMMITTEE_ROLE = "cargo_comissoes_etica";
export const FORM_FIELD_ETHICS_COMMITTEE_WORKPLACE = "instituicao_comissoes_etica";
export const FORM_FIELD_ETHICS_COMMITTEE_BEGIN_DATE = "data_inicio_comissoes_etica";
export const FORM_FIELD_ETHICS_COMMITTEE_END_DATE = "data_fim_comissoes_etica";

export const FORM_FIELD_ETHICS_COMMITTEE_ROLE_1 = FORM_FIELD_ETHICS_COMMITTEE_ROLE + "1";
export const FORM_FIELD_ETHICS_COMMITTEE_WORKPLACE_1 = FORM_FIELD_ETHICS_COMMITTEE_WORKPLACE + "1";
export const FORM_FIELD_ETHICS_COMMITTEE_BEGIN_DATE_1 = FORM_FIELD_ETHICS_COMMITTEE_BEGIN_DATE + "1";
export const FORM_FIELD_ETHICS_COMMITTEE_END_DATE_1 = FORM_FIELD_ETHICS_COMMITTEE_END_DATE + "1";

export const FORM_FIELD_ETHICS_COMMITTEE_ROLE_2 = FORM_FIELD_ETHICS_COMMITTEE_ROLE + "2";
export const FORM_FIELD_ETHICS_COMMITTEE_WORKPLACE_2 = FORM_FIELD_ETHICS_COMMITTEE_WORKPLACE + "2";
export const FORM_FIELD_ETHICS_COMMITTEE_BEGIN_DATE_2 = FORM_FIELD_ETHICS_COMMITTEE_BEGIN_DATE + "2";
export const FORM_FIELD_ETHICS_COMMITTEE_END_DATE_2 = FORM_FIELD_ETHICS_COMMITTEE_END_DATE + "2";

export const FORM_FIELD_ETHICS_COMMITTEE_ROLE_3 = FORM_FIELD_ETHICS_COMMITTEE_ROLE + "3";
export const FORM_FIELD_ETHICS_COMMITTEE_WORKPLACE_3 = FORM_FIELD_ETHICS_COMMITTEE_WORKPLACE + "3";
export const FORM_FIELD_ETHICS_COMMITTEE_BEGIN_DATE_3 = FORM_FIELD_ETHICS_COMMITTEE_BEGIN_DATE + "3";
export const FORM_FIELD_ETHICS_COMMITTEE_END_DATE_3 = FORM_FIELD_ETHICS_COMMITTEE_END_DATE + "3";

export const FORM_FIELD_QUALITY_COMMITTEE_ROLE = "cargo_comissoes_qualidade";
export const FORM_FIELD_QUALITY_COMMITTEE_WORKPLACE = "instituicao_comissoes_qualidade";
export const FORM_FIELD_QUALITY_COMMITTEE_BEGIN_DATE = "data_inicio_comissoes_qualidade";
export const FORM_FIELD_QUALITY_COMMITTEE_END_DATE = "data_fim_comissoes_qualidade";

export const FORM_FIELD_QUALITY_COMMITTEE_ROLE_1 = FORM_FIELD_QUALITY_COMMITTEE_ROLE + "1";
export const FORM_FIELD_QUALITY_COMMITTEE_WORKPLACE_1 = FORM_FIELD_QUALITY_COMMITTEE_WORKPLACE + "1";
export const FORM_FIELD_QUALITY_COMMITTEE_BEGIN_DATE_1 = FORM_FIELD_QUALITY_COMMITTEE_BEGIN_DATE + "1";
export const FORM_FIELD_QUALITY_COMMITTEE_END_DATE_1 = FORM_FIELD_QUALITY_COMMITTEE_END_DATE + "1";

export const FORM_FIELD_QUALITY_COMMITTEE_ROLE_2 = FORM_FIELD_QUALITY_COMMITTEE_ROLE + "2";
export const FORM_FIELD_QUALITY_COMMITTEE_WORKPLACE_2 = FORM_FIELD_QUALITY_COMMITTEE_WORKPLACE + "2";
export const FORM_FIELD_QUALITY_COMMITTEE_BEGIN_DATE_2 = FORM_FIELD_QUALITY_COMMITTEE_BEGIN_DATE + "2";
export const FORM_FIELD_QUALITY_COMMITTEE_END_DATE_2 = FORM_FIELD_QUALITY_COMMITTEE_END_DATE + "2";

export const FORM_FIELD_QUALITY_COMMITTEE_ROLE_3 = FORM_FIELD_QUALITY_COMMITTEE_ROLE + "3";
export const FORM_FIELD_QUALITY_COMMITTEE_WORKPLACE_3 = FORM_FIELD_QUALITY_COMMITTEE_WORKPLACE + "3";
export const FORM_FIELD_QUALITY_COMMITTEE_BEGIN_DATE_3 = FORM_FIELD_QUALITY_COMMITTEE_BEGIN_DATE + "3";
export const FORM_FIELD_QUALITY_COMMITTEE_END_DATE_3 = FORM_FIELD_QUALITY_COMMITTEE_END_DATE + "3";


export const FORM_FIELD_ORGANIZATIONAL_WORKPLACE = "instituicao_filiado";
export const FORM_FIELD_ORGANIZATIONAL_BEGIN_DATE = "data_inicio_filiado";
export const FORM_FIELD_ORGANIZATIONAL_END_DATE = "data_fim_filiado";

export const FORM_FIELD_ORGANIZATIONAL_WORKPLACE_1 = FORM_FIELD_ORGANIZATIONAL_WORKPLACE + "1";
export const FORM_FIELD_ORGANIZATIONAL_BEGIN_DATE_1 = FORM_FIELD_ORGANIZATIONAL_BEGIN_DATE + "1";
export const FORM_FIELD_ORGANIZATIONAL_END_DATE_1 = FORM_FIELD_ORGANIZATIONAL_END_DATE + "1";

export const FORM_FIELD_ORGANIZATIONAL_WORKPLACE_2 = FORM_FIELD_ORGANIZATIONAL_WORKPLACE + "2";
export const FORM_FIELD_ORGANIZATIONAL_BEGIN_DATE_2 = FORM_FIELD_ORGANIZATIONAL_BEGIN_DATE + "2";
export const FORM_FIELD_ORGANIZATIONAL_END_DATE_2 = FORM_FIELD_ORGANIZATIONAL_END_DATE + "2";

export const FORM_FIELD_ORGANIZATIONAL_WORKPLACE_3 = FORM_FIELD_ORGANIZATIONAL_WORKPLACE + "3";
export const FORM_FIELD_ORGANIZATIONAL_BEGIN_DATE_3 = FORM_FIELD_ORGANIZATIONAL_BEGIN_DATE + "3";
export const FORM_FIELD_ORGANIZATIONAL_END_DATE_3 = FORM_FIELD_ORGANIZATIONAL_END_DATE + "3";

export const FORM_FIELD_ORGANIZATIONAL_WORKPLACE_4 = FORM_FIELD_ORGANIZATIONAL_WORKPLACE + "4";
export const FORM_FIELD_ORGANIZATIONAL_BEGIN_DATE_4 = FORM_FIELD_ORGANIZATIONAL_BEGIN_DATE + "4";
export const FORM_FIELD_ORGANIZATIONAL_END_DATE_4 = FORM_FIELD_ORGANIZATIONAL_END_DATE + "4";

export const FORM_FIELD_ORGANIZATIONAL_WORKPLACE_5 = FORM_FIELD_ORGANIZATIONAL_WORKPLACE + "5";
export const FORM_FIELD_ORGANIZATIONAL_BEGIN_DATE_5 = FORM_FIELD_ORGANIZATIONAL_BEGIN_DATE + "5";
export const FORM_FIELD_ORGANIZATIONAL_END_DATE_5 = FORM_FIELD_ORGANIZATIONAL_END_DATE + "5";

export const FORM_FIELD_ORGANIZATIONAL_WORKPLACE_6 = FORM_FIELD_ORGANIZATIONAL_WORKPLACE + "6";
export const FORM_FIELD_ORGANIZATIONAL_BEGIN_DATE_6 = FORM_FIELD_ORGANIZATIONAL_BEGIN_DATE + "6";
export const FORM_FIELD_ORGANIZATIONAL_END_DATE_6 = FORM_FIELD_ORGANIZATIONAL_END_DATE + "6";

export const FORM_FIELD_ORGANIZATIONAL_WORKPLACE_7 = FORM_FIELD_ORGANIZATIONAL_WORKPLACE + "7";
export const FORM_FIELD_ORGANIZATIONAL_BEGIN_DATE_7 = FORM_FIELD_ORGANIZATIONAL_BEGIN_DATE + "7";
export const FORM_FIELD_ORGANIZATIONAL_END_DATE_7 = FORM_FIELD_ORGANIZATIONAL_END_DATE + "7";

export const FORM_FIELD_ORGANIZATIONAL_WORKPLACE_8 = FORM_FIELD_ORGANIZATIONAL_WORKPLACE + "8";
export const FORM_FIELD_ORGANIZATIONAL_BEGIN_DATE_8 = FORM_FIELD_ORGANIZATIONAL_BEGIN_DATE + "8";
export const FORM_FIELD_ORGANIZATIONAL_END_DATE_8 = FORM_FIELD_ORGANIZATIONAL_END_DATE + "8";

export const FORM_FIELD_ORGANIZATIONAL_WORKPLACE_9 = FORM_FIELD_ORGANIZATIONAL_WORKPLACE + "9";
export const FORM_FIELD_ORGANIZATIONAL_BEGIN_DATE_9 = FORM_FIELD_ORGANIZATIONAL_BEGIN_DATE + "9";
export const FORM_FIELD_ORGANIZATIONAL_END_DATE_9 = FORM_FIELD_ORGANIZATIONAL_END_DATE + "9";

export const FORM_FIELD_ORGANIZATIONAL_WORKPLACE_10 = FORM_FIELD_ORGANIZATIONAL_WORKPLACE + "10";
export const FORM_FIELD_ORGANIZATIONAL_BEGIN_DATE_10 = FORM_FIELD_ORGANIZATIONAL_BEGIN_DATE + "10";
export const FORM_FIELD_ORGANIZATIONAL_END_DATE_10 = FORM_FIELD_ORGANIZATIONAL_END_DATE + "10";


export const FORM_STEP_8_STATE = "step8State";

// Step 9
export const FORM_FIELD_PROFESSIONAL_EXPERIENCE = "tem_experiencia_em_fisioterapia";
export const FORM_FIELD_PROFESSIONAL_ENTITY = "entidade_profissional";
export const FORM_FIELD_PROFESSIONAL_STREET_TYPE = "arteriaCTT_profissional";
export const FORM_FIELD_PROFESSIONAL_ADDRESS_LINE = "morada1_profissional";
export const FORM_FIELD_PROFESSIONAL_DOOR_NUMBER = "porta_profissional";
export const FORM_FIELD_PROFESSIONAL_DOOR_FLOOR = "andar_profissional";
export const FORM_FIELD_PROFESSIONAL_AUX_PLACE = "localidade_auxiliar_profissional";
export const FORM_FIELD_PROFESSIONAL_CP4 = "codigo_postal_profissional1";
export const FORM_FIELD_PROFESSIONAL_CP3 = "codigo_postal_profissional2";
export const FORM_FIELD_PROFESSIONAL_CITY = "localidade_profissional";
export const FORM_FIELD_PROFESSIONAL_COUNTY = "concelho_profissional";
export const FORM_FIELD_PROFESSIONAL_DISTRICT = "distrito_profissional";
export const FORM_FIELD_PROFESSIONAL_MAIN_ACTIVITY = "atividade_principal";
export const FORM_FIELD_PROFESSIONAL_MAIN_ACTIVITY_CONTRACT = "atividade_principaltipo_contrato";
export const FORM_FIELD_PROFESSIONAL_MAIN_ACTIVITY_CONTEXT = "atividade_principal_contexto";
export const FORM_FIELD_PROFESSIONAL_SECONDARY_ACTIVITY = "exerce_atividades_secundarias";
export const FORM_FIELD_PROFESSIONAL_SECONDARY_ACTIVITY_CONTEXT = "atividade_secundaria_contexto";
export const FORM_FIELD_PROFESSIONAL_CLINIC_ACTIVITY = "exerce_atividade_clinica";
export const FORM_FIELD_PROFESSIONAL_EXERCISE_TYPE = "caracterizacao_do_exercicio_profissional";
export const FORM_FIELD_PROFESSIONAL_WORKPLACES_NUMBER = "quantos_locais_exerce_funcoes";
export const FORM_FIELD_PROFESSIONAL_WEEKLY_HOURS = "horas_semanais_no_exercicio_de_funcoes";
export const FORM_FIELD_HEARTH_HEALTH_ACTIVITIES = "cardiovascular9";
export const FORM_FIELD_NEURO_HEALTH_ACTIVITIES = "neurologia9";
export const FORM_FIELD_WOMEN_HEALTH_ACTIVITIES = "saude_da_mulher9";
export const FORM_FIELD_MENTAL_HEALTH_ACTIVITIES = "saude_mental9";
export const FORM_FIELD_MUSCLE_HEALTH_ACTIVITIES = "muscoloesqueletica9";
export const FORM_FIELD_ANIMAL_HEALTH_ACTIVITIES = "saude_animal9";
export const FORM_FIELD_OTHER_CONDITIONS_ACTIVITIES = "outras_condicoes9";
export const FORM_FIELD_WELL_BEING_HEALTH_ACTIVITIES = "saude_e_bem_estar9";
export const FORM_FIELD_COMPLEX_SCENARIOS_ACTIVITIES = "elevada_complexidade9";
export const FORM_FIELD_OCCUPATION_HEALTH_ACTIVITIES = "saude_ocupacional9";
export const FORM_FIELD_ONCOLOGICAL_HEALTH_ACTIVITIES = "oncologicas9";
export const FORM_FIELD_RESPIRATORY_HEALTH_ACTIVITIES = "respiratorias9";
export const FORM_FIELD_INTEGUMENTAL_HEALTH_ACTIVITIES = "tegumentares9";
export const FORM_FIELD_PROMOTION_PROTECTION_HEALTH_ACTIVITIES = "promocao_e_protecao_da_saude9";
export const FORM_STEP_9_STATE = "step9State";

// Step 10
export const FORM_FIELD_CV_TYPE = "cvType";
export const FORM_FIELD_CV_URL = "cv_url";
export const FORM_STEP_10_STATE = "step10State";
// Step 11
export const FORM_STEP_11_STATE = "step11State";

// Step state
export const STEP_STATE_NOT_SUBMITTED = 0;
export const STEP_STATE_VALIDATION_ERROR = 1;
export const STEP_STATE_SUBMITTED = 2;


// Online store product metadata
export const PRODUCT_KEY_MESSAGE = "MESSAGE";
export const PRODUCT_KEY_REASON = "REASON";
export const PRODUCT_KEY_SUSPENSION_TYPE = "SUSPENSION_TYPE";
export const PRODUCT_KEY_SUSPENSION_DATE = "SUSPENSION_DATE";
export const PRODUCT_KEY_SUSPENSION_END_DATE = "SUSPENSION_END_DATE";
export const PRODUCT_KEY_COUNTRY = "COUNTRY";
export const PRODUCT_KEY_PROFESSIONAL_NAME = "PROFESSIONAL_NAME";
export const PRODUCT_KEY_NAME = "NAME";
export const PRODUCT_KEY_IDENTIFICATION_NUMBER = "IDENTIFICATION_NUMBER";
export const PRODUCT_KEY_FISCAL_NUMBER = "FISCAL_NUMBER";
export const PRODUCT_KEY_EMAIL = "EMAIL";
export const PRODUCT_KEY_PHONE_NUMBER = "PHONE_NUMBER";
export const PRODUCT_KEY_REGISTRATION_REF = "REGISTRATION_REF";
export const PRODUCT_KEY_VINHETAS_FORMAT = "VINHETAS_FORMAT";
export const PRODUCT_KEY_VINHETAS_PACKS = "VINHETAS_PACKS";

export const PRODUCT_SUSPENSION_CANCELLATION_REF = "584668ec-d871-4139-b8f4-2d83ee6460c6";
export const PRODUCT_SUSPENSION_CANCELLATION_NAME = "suspension-cancellation";
export const PRODUCT_SUSPENSION_CANCELLATION_PRICE = 0;
export const PRODUCT_SUSPENSION_INVOICE_ITEM = "7314322";

export const PRODUCT_CLOSE_SUSPENSION_REF = "35d8fb8d-4284-459b-aa5f-b177b83bc587";
export const PRODUCT_CLOSE_SUSPENSION_NAME = "close-suspension";
export const PRODUCT_CLOSE_SUSPENSION_PRICE = 75;

// Training Areas
export const TRAINING_AREA_CONGRESS = 4;

// Training Audience
export const TRAINING_AUDIENCE_PUBLIC = 1;
export const TRAINING_AUDIENCE_MEMBERS = 2;

// Training Questionnaire question type
export const QUESTION_TYPE_TEXT = 1;
export const QUESTION_TYPE_SINGLE_OPTION = 2;
export const QUESTION_TYPE_MULTIPLE_OPTION = 3;
export const QUESTION_TYPE_RATING = 4;